// import { useEffect, useState, useRef } from "react";
// import Footer from "../components/Footer";
// import Header from "../components/Header";
// import axios from "axios";
// import config from "../config/config.json";
// import { FaLinkedin, FaTimes } from "react-icons/fa";
 
// const Sponsors1 = () => {
//     const [sponsors, setSponsors] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [expandedMessages, setExpandedMessages] = useState({});
//     const [selectedSponsor, setSelectedSponsor] = useState(null);
 
//     // Function to open modal with sponsor data
//     const openModal = (sponsor) => {
//         setSelectedSponsor(sponsor);
//     };
 
//     // Function to close modal
//     const closeModal = () => {
//         setSelectedSponsor(null);
//     };
 
//     const toggleMessageExpansion = (sponsorId) => {
//         setExpandedMessages((prev) => ({
//             ...prev,
//             [sponsorId]: !prev[sponsorId],
//         }));
//     };
 
//     useEffect(() => {
//         const fetchSponsors = async () => {
//             try {
//                 const response = await axios.get(
//                     `${config.APP_URL}/sponsor/sponsors/verified`
//                 );
//                 // console.log("request:", response.data);
//                 setSponsors(response.data.sponsors);
 
//                 // Initialize all messages as not expanded
//                 const initialExpandedState = {};
//                 response.data.sponsors.forEach((sponsor) => {
//                     initialExpandedState[sponsor.sponsor_id] = false;
//                 });
//                 setExpandedMessages(initialExpandedState);
//             } catch (error) {
//                 console.error("Error fetching sponsors:", error);
//             } finally {
//                 setLoading(false);
//             }
//         };
 
//         fetchSponsors();
//     }, []);
 
//     if (loading) {
//         return (
//             <div className="flex justify-center items-center h-64">
//                 <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
//             </div>
//         );
//     }
 
//     if (sponsors.length === 0) {
//         return (
//             <div className="text-center py-12">
//                 <h3 className="text-xl font-medium text-gray-600">
//                     No sponsors available at the moment
//                 </h3>
//             </div>
//         );
//     }
 
//     return (
//         <>
 
           
 
//             <Header />
//             <div className="flex flex-col min-h-screen">
//                 <div className="flex-grow flex items-center justify-center py-8">
//                     <section className="px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 to-white w-full">
//                         <div className="max-w-7xl mx-auto">
//                             <div className="text-center mb-12">
//                                 <h2 className="text-3xl font-extrabold text-gray-900 sm:text-5xl">
//                                     Our <span className="text-blue-600">Supporters</span> and <span className="text-blue-600">Sponsors</span>
//                                 </h2>
//                                 <p className="mt-4 text-xl text-gray-600">
//                                     UTahData.org is deeply grateful for the generous support of these distinguished organizations and visionary individuals who help make our mission possible.
//                                 </p>
//                             </div>
 
//                             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//                                 {sponsors.map((sponsor) => {
//                                     const isLongMessage = sponsor.message.length > 120;
 
//                                     return (
//                                         <div
//                                             key={sponsor.sponsor_id}
//                                             className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 flex flex-col"
//                                         >
//                                             <div className="p-6 flex-grow">
//                                                 <div className="flex items-start mb-4">
//                                                     <div className="flex-shrink-0 h-28 w-28 rounded-xl bg-blue-100 flex items-center justify-center">
//                                                         {sponsor.pic_path ? (
//                                                             <img
//                                                                 src={`/img/sponsors/${sponsor.pic_path}`}
//                                                                 alt={sponsor.name}
//                                                                 className="h-full w-full object-cover rounded-xl"
//                                                             />
//                                                         ) : (
//                                                             <span className="text-blue-600 text-xl font-bold">
//                                                                 {sponsor.name.charAt(0)}
//                                                             </span>
//                                                         )}
//                                                     </div>
//                                                     <div className="ml-4">
//                                                         <h3 className="text-lg font-semibold text-gray-900">
//                                                             {sponsor.name}
//                                                         </h3>
 
//                                                         {sponsor.designation && (
//                                                             <p className="text-sm text-gray-500 leading-snug sm:text-xs">
//                                                                 {sponsor.designation}
//                                                             </p>
//                                                         )}
//                                                         <div className="flex space-x-1 items-center">
//                                                             {sponsor.linkedin_url && (
//                                                                 <a
//                                                                     href={sponsor.linkedin_url}
//                                                                     target="_blank"
//                                                                     rel="noopener noreferrer"
//                                                                     className="text-blue-500 hover:text-blue-700 text-sm flex space-x-1 items-center"
//                                                                 >
//                                                                     <FaLinkedin />
//                                                                     <span> LinkedIn Profile</span>
//                                                                 </a>
//                                                             )}
//                                                         </div>
//                                                     </div>
//                                                 </div>
 
//                                                 <div className="mb-4">
//                                                     <p
//                                                         className="text-gray-600 line-clamp-3 text-justify"
//                                                     >
//                                                         "{sponsor.message}"
//                                                     </p>
//                                                     {isLongMessage && (
//                                                         <button
//                                                             onClick={() => openModal(sponsor)}
//                                                             className="text-blue-500 hover:text-blue-700 text-sm mt-1 focus:outline-none focus:ring-2 focus:ring-blue-300 rounded"
//                                                             aria-label="Read more"
//                                                         >
//                                                             ...Read more
//                                                         </button>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     );
//                                 })}
//                             </div>
//                         </div>
//                     </section>
//                 </div>
//             </div>
 
//             {/* Modal for sponsor details */}
//             {selectedSponsor && (
//                 <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//                     <div className="bg-white rounded-xl shadow-2xl max-w-6xl w-full max-h-[90vh] overflow-y-auto">
//                         <div className="flex justify-between items-center p-6 border-b">
//                             <h3 className="text-2xl font-bold text-gray-900">Sponsor Details</h3>
//                             {/* <button
//                                 onClick={closeModal}
//                                 className="text-gray-500 hover:text-gray-700 focus:outline-none z-50"
//                                 aria-label="Close modal"
//                             >
//                                 <FaTimes className="h-6 w-6" />
//                             </button> */}
//                         </div>
 
//                         <div className="p-6">
//                             <div className="flex flex-col md:flex-row gap-6">
//                                 {/* Left side - Image */}
//                                 <div className="md:w-1/3 flex flex-col items-center">
//                                     <div className=" w-64 h-64 rounded-xl bg-blue-100 flex items-center justify-center mb-4">
//                                         {selectedSponsor.pic_path ? (
//                                             <img
//                                                 src={`/img/sponsors/${selectedSponsor.pic_path}`}
//                                                 alt={selectedSponsor.name}
//                                                 className="w-full h-full object-cover rounded-xl"
//                                             />
//                                         ) : (
//                                             <span className="text-blue-600 text-4xl font-bold">
//                                                 {selectedSponsor.name.charAt(0)}
//                                             </span>
//                                         )}
//                                     </div>
 
//                                     {selectedSponsor.linkedin_url && (
//                                         <a
//                                             href={selectedSponsor.linkedin_url}
//                                             target="_blank"
//                                             rel="noopener noreferrer"
//                                             className="text-blue-500 hover:text-blue-700 flex items-center gap-2"
//                                         >
//                                             <FaLinkedin className="h-5 w-5" />
//                                             <span>Connect on LinkedIn</span>
//                                         </a>
//                                     )}
//                                 </div>
 
//                                 {/* Right side - Details */}
//                                 <div className="md:w-2/3">
//                                     <h2 className="text-2xl font-bold text-gray-900 mb-2">
//                                         {selectedSponsor.name}
//                                     </h2>
 
//                                     {selectedSponsor.designation && (
//                                         <p className="text-gray-600 mb-4">
//                                             {selectedSponsor.designation}
//                                         </p>
//                                     )}
 
//                                     <div className="bg-gray-50 p-4 rounded-lg">
//                                         <h4 className="font-semibold text-gray-800 mb-2">Message:</h4>
//                                         <p className="text-gray-700 ">
//                                             "{selectedSponsor.message}"
//                                         </p>
//                                     </div>
 
//                                     {/* Additional details can be added here if needed */}
//                                 </div>
//                             </div>
//                         </div>
 
//                         <div className="p-6 border-t flex justify-end">
//                             <button
//                                 onClick={closeModal}
//                                 className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
//                             >
//                                 Close
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//             <Footer />
//         </>
//     );
// };
 
// export default Sponsors1;




















import { useEffect, useState, useRef } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import axios from "axios";
import config from "../config/config.json";
import { FaLinkedin } from "react-icons/fa";

const Sponsors1 = () => {
  const [sponsors, setSponsors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedMessages, setExpandedMessages] = useState({});
  const [selectedSponsor, setSelectedSponsor] = useState(null);

  const dropdownRef = useRef(null);

  const openModal = (sponsor) => setSelectedSponsor(sponsor);
  const closeModal = () => setSelectedSponsor(null);

  const toggleMessageExpansion = (sponsorId) => {
    setExpandedMessages((prev) => ({
      ...prev,
      [sponsorId]: !prev[sponsorId],
    }));
  };

  useEffect(() => {
    const fetchSponsors = async () => {
      try {
        const response = await axios.get(
          `${config.APP_URL}/sponsor/sponsors/verified`
        );

        const list = Array.isArray(response?.data?.sponsors)
          ? response.data.sponsors
          : [];

        setSponsors(list);

        // Initialize all messages as not expanded (safe on missing ids)
        const initialExpandedState = {};
        list.forEach((s) => {
          const id = s?.sponsor_id ?? s?.id ?? s?.name ?? Math.random().toString(36).slice(2);
          initialExpandedState[id] = false;
        });
        setExpandedMessages(initialExpandedState);
      } catch (error) {
        console.error("Error fetching sponsors:", error);
        setSponsors([]); // ensure array fallback on error
      } finally {
        setLoading(false);
      }
    };

    fetchSponsors();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500" />
      </div>
    );
  }

  if (!Array.isArray(sponsors) || sponsors.length === 0) {
    return (
      <>
        <Header />
        <div className="text-center py-12 min-h-[50vh] flex items-center justify-center">
          <h3 className="text-xl font-medium text-gray-600">
            No sponsors available at the moment
          </h3>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="flex flex-col min-h-screen">
        <div className="flex-grow flex items-center justify-center py-8">
          <section className="px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 to-white w-full">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="text-3xl font-extrabold text-gray-900 sm:text-5xl">
                  Our <span className="text-blue-600">Supporters</span> and{" "}
                  <span className="text-blue-600">Sponsors</span>
                </h2>
                <p className="mt-4 text-xl text-gray-600">
                  UTahData.org is deeply grateful for the generous support of
                  these distinguished organizations and visionary individuals who
                  help make our mission possible.
                </p>
              </div>

              {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"> */}
               <div className="flex flex-wrap gap-8 justify-center items-center">
                {sponsors.map((sponsor, idx) => {
                  const id =
                    sponsor?.sponsor_id ??
                    sponsor?.id ??
                    sponsor?.name ??
                    `row-${idx}`;

                  const name = sponsor?.name ?? "Anonymous";
                  const message = sponsor?.message ?? "";
                  const isLongMessage = (message?.length ?? 0) > 120;

                  return (
                    <div
                      key={id}
                      className="bg-white rounded-xl shadow-lg w-[30rem] overflow-hidden hover:shadow-xl transition-shadow duration-300 flex 
                      justify-center item-center"
                    >
                      <div className="p-6 flex-grow">
                        <div className="flex items-start mb-4">
                          <div className="flex-shrink-0 h-28 w-28 rounded-xl bg-blue-100 flex items-center justify-center overflow-hidden">
                            {sponsor?.pic_path ? (
                              <img
                                src={`/img/sponsors/${sponsor.pic_path}`}
                                alt={name}
                                className="h-full w-full object-cover rounded-xl"
                              />
                            ) : (
                              <span className="text-blue-600 text-xl font-bold">
                                {name?.charAt?.(0) || "?"}
                              </span>
                            )}
                          </div>

                          <div className="ml-4">
                            <h3 className="text-lg font-semibold text-gray-900">
                              {name}
                            </h3>

                            {sponsor?.designation && (
                              <p className="text-sm text-gray-500 leading-snug sm:text-xs">
                                {sponsor.designation}
                              </p>
                            )}

                            <div className="flex space-x-1 items-center">
                              {sponsor?.linkedin_url && (
                                <a
                                  href={sponsor.linkedin_url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-blue-500 hover:text-blue-700 text-sm flex space-x-1 items-center"
                                >
                                  <FaLinkedin />
                                  <span> LinkedIn Profile</span>
                                </a>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="mb-4">
                          <p className="text-gray-600 line-clamp-3 text-justify">
                            {message ? `"${message}"` : "No message provided."}
                          </p>

                          {isLongMessage && (
                            <button
                              onClick={() => openModal(sponsor)}
                              className="text-blue-500 hover:text-blue-700 text-sm mt-1 focus:outline-none focus:ring-2 focus:ring-blue-300 rounded"
                              aria-label="Read more"
                            >
                              ...Read more
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* Modal for sponsor details */}
      {selectedSponsor && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl shadow-2xl max-w-6xl w-full max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center p-6 border-b">
              <h3 className="text-2xl font-bold text-gray-900">
                Sponsor Details
              </h3>
            </div>

            <div className="p-6">
              <div className="flex flex-col md:flex-row gap-6">
                {/* Left side - Image */}
                <div className="md:w-1/3 flex flex-col items-center">
                  <div className="w-64 h-64 rounded-xl bg-blue-100 flex items-center justify-center mb-4 overflow-hidden">
                    {selectedSponsor?.pic_path ? (
                      <img
                        src={`/img/sponsors/${selectedSponsor.pic_path}`}
                        alt={selectedSponsor?.name ?? "Sponsor"}
                        className="w-full h-full object-cover rounded-xl"
                      />
                    ) : (
                      <span className="text-blue-600 text-4xl font-bold">
                        {selectedSponsor?.name?.charAt?.(0) || "?"}
                      </span>
                    )}
                  </div>

                  {selectedSponsor?.linkedin_url && (
                    <a
                      href={selectedSponsor.linkedin_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-500 hover:text-blue-700 flex items-center gap-2"
                    >
                      <FaLinkedin className="h-5 w-5" />
                      <span>Connect on LinkedIn</span>
                    </a>
                  )}
                </div>

                {/* Right side - Details */}
                <div className="md:w-2/3">
                  <h2 className="text-2xl font-bold text-gray-900 mb-2">
                    {selectedSponsor?.name ?? "Anonymous"}
                  </h2>

                  {selectedSponsor?.designation && (
                    <p className="text-gray-600 mb-4">
                      {selectedSponsor.designation}
                    </p>
                  )}

                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-gray-800 mb-2">
                      Message:
                    </h4>
                    <p className="text-gray-700">
                      {selectedSponsor?.message
                        ? `"${selectedSponsor.message}"`
                        : "No message provided."}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-6 border-t flex justify-end">
              <button
                onClick={closeModal}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default Sponsors1;
